import { useFeatures } from '../../../../hooks';
import { MedicalResultSource } from '../../../../services/MedicalResultsService';

export type LabResultsConfigItem = {
  title: string;
  coding?: Required<Pick<fhir.Coding, 'system' | 'code'>>;
  source?: MedicalResultSource;
};

type LabResultsConfig = LabResultsConfigItem[];

export const useLabResultsConfig = (): LabResultsConfig => {
  const getFeatureFlag = useFeatures();
  const isMemberUploadsEnabled = getFeatureFlag('phcMemberUploadsData');
  const isUncategorizedEnabled = getFeatureFlag('phcUncategorizedLabsData');

  return [
    {
      title: 'Cardiovascular',
      coding: {
        code: 'cardiovascular',
        system: 'http://lifeomic.com/fhir/medical-results/systems',
      },
    },
    {
      title: 'Metabolic',
      coding: {
        code: 'metabolic',
        system: 'http://lifeomic.com/fhir/medical-results/systems',
      },
    },
    {
      title: 'Hormones',
      coding: {
        code: 'hormones',
        system: 'http://lifeomic.com/fhir/medical-results/systems',
      },
    },
    {
      title: 'Thyroid',
      coding: {
        code: 'thyroid',
        system: 'http://lifeomic.com/fhir/medical-results/systems',
      },
    },
    {
      title: 'Inflammation',
      coding: {
        code: 'inflammation',
        system: 'http://lifeomic.com/fhir/medical-results/systems',
      },
    },
    {
      title: 'Nutrients',
      coding: {
        code: 'nutrients',
        system: 'http://lifeomic.com/fhir/medical-results/systems',
      },
    },
    {
      title: 'Immune',
      coding: {
        code: 'immune',
        system: 'http://lifeomic.com/fhir/medical-results/systems',
      },
    },
    {
      title: 'Blood',
      coding: {
        code: 'blood',
        system: 'http://lifeomic.com/fhir/medical-results/systems',
      },
    },
    {
      title: 'Kidney',
      coding: {
        code: 'kidney',
        system: 'http://lifeomic.com/fhir/medical-results/systems',
      },
    },
    {
      title: 'Liver',
      coding: {
        code: 'liver',
        system: 'http://lifeomic.com/fhir/medical-results/systems',
      },
    },
    {
      title: 'Prostate',
      coding: {
        code: 'prostate',
        system: 'http://lifeomic.com/fhir/medical-results/systems',
      },
    },
    {
      title: 'GI Health',
      coding: {
        code: 'gi-health',
        system: 'http://lifeomic.com/fhir/medical-results/systems',
      },
    },
    {
      title: 'Cancer Markers',
      coding: {
        code: 'cancer-markers',
        system: 'http://lifeomic.com/fhir/medical-results/systems',
      },
    },
    ...(isUncategorizedEnabled
      ? [{ title: 'Uncategorized', source: 'unmappedLabs' as const }]
      : []),
    ...(isMemberUploadsEnabled
      ? [
          {
            title: 'Bring Your Own Health Data',
            source: 'memberUpload' as const,
          },
        ]
      : []),
  ];
};
